module.exports = __webpack_public_path__ + "static/card-img-0fc7deb16731e5a07c16dad53ba71c7a.png";